//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class GroupListModel extends ModelBase {
      static readonly $typeName = 'GroupListModel';
      public canEdit: boolean;
      public key: string;
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/GroupListModel.ts